import { cva, type VariantProps } from 'class-variance-authority';

export const accordionVariants = cva(
  [
    // Reserve border space so changing variants does not resize the item.
    'border',
    'outline-none',
    // Focus state
    'focus:border-neutral-500 focus-visible:ring focus-visible:ring-neutral-100',
    // Disabled state
    'disabled:pointer-events-none disabled:opacity-50',
  ],
  {
    variants: {
      variant: {
        'no-background':
          'border-x-transparent border-t-transparent border-b-neutral-200',
        white: 'bg-white rounded-sm border-neutral-200',
        neutral: 'bg-neutral-50 rounded-sm border-transparent',
        primary: 'bg-primary-50 border-primary-700 rounded-sm',
        secondary: 'bg-secondary-50 border-secondary-700 rounded-sm',
        onDark:
          'border-x-transparent border-t-transparent border-b-neutral-500 text-white [&_[data-slot=accordion-trigger-icon]]:text-white [&_.text-body]:text-white [&_.text-heading]:text-white',
      },
      // Radius for the carded `white` / `neutral` variants only, applied via
      // `compoundVariants`; `sm` matches today's baked `rounded-sm`, so unset is unchanged.
      radius: {
        sm: '',
        md: '',
        lg: '',
        xl: '',
      },
    },
    compoundVariants: [
      { variant: 'white', radius: 'md', className: 'rounded-md' },
      { variant: 'white', radius: 'lg', className: 'rounded-lg' },
      { variant: 'white', radius: 'xl', className: 'rounded-xl' },
      { variant: 'neutral', radius: 'md', className: 'rounded-md' },
      { variant: 'neutral', radius: 'lg', className: 'rounded-lg' },
      { variant: 'neutral', radius: 'xl', className: 'rounded-xl' },
    ],
    defaultVariants: {
      variant: 'no-background',
      radius: 'sm',
    },
  },
);

export type AccordionVariantProps = VariantProps<typeof accordionVariants>;
